export default __webpack_public_path__ + "static/media/city-hall-survey-negative.f3b7294b.svg";